import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center ml-auto relative" }
const _hoisted_2 = ["value"]

import { MinusIcon, PlusIcon } from "@heroicons/vue/24/solid";
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'QuantitySelector',
  setup(__props) {

const count = ref<number>(0)

function increment() {
  count.value++
}

function decrement() {
  count.value--
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (decrement())),
      class: ""
    }, [
      _createVNode(_unref(MinusIcon), { class: "w-6 h-6" })
    ]),
    _createElementVNode("input", {
      type: "text",
      class: "w-10 border-0 text-center p-0 focus:ring-0 bg-transparent",
      value: count.value
    }, null, 8, _hoisted_2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (increment())),
      class: ""
    }, [
      _createVNode(_unref(PlusIcon), { class: "w-6 h-6" })
    ])
  ]))
}
}

})